import $http from './index';
// ticket验证
export function ticektCheck() {
    return $http.post(
        `/user/ticket`, {}, {
            headers: {
                ticket: window.sessionStorage.getItem('ticket'),
                service: window.sessionStorage.getItem('serviceUrl')
            }
        }
    )
}

//临时
export function loginCas(userName) {
    return $http.get(
        `/cas`, {
            params: {
                url: userName,
                ticket: userName,
            },
            headers: { loginType: window.localStorage.getItem('loginType') }
        }
    )
}

// 登录
export function login(userName, password, captcha) {
    return $http
        .post('/login', { username: userName, password: password, captcha: captcha });
}

// 退出
export function loginOut() {
    return $http
        .get('/logout')
}
//获取登录用户对应的角色
export function getUserRole(id) {
    return $http
        .get('/user/getRoles/' + id)
}
export function getUserInfo(id) {
    return $http
        .get('/user/getUserInfo/' + id)
}

//院系list
export function departmentList(data) {
    return $http
        .post('/department/list', data)
}

//课程list
export function curriculumList(data) {
    return $http
        .post('/curriculum/page', data)
}

export function curriculumPageHot(data) {
    return $http
        .post('/curriculum/pageHot', data)
}

//发布课程
export function batchpublish(data) {
    return $http
        .post('/curriculum/publish', { idList: data })
}

//禁用课程
export function batchdisable(data) {
    return $http
        .post('/curriculum/disable', { idList: data })
}

//删除课程
export function curriculumdelete(data) {
    return $http
        .post('/curriculum/delete', data)
}


//课程下讲师
export function curriculumLecturer(data) {
    return $http
        .post('/curriculum/lecturer', data)
}

//课程下视频列表
export function pageByCurriculum(data) {
    return $http.post("/video/pageByCurriculum", data);
}
//专题下视频列表
export function pageBySubject(data) {
    return $http.post("/video/pageBySubject", data);
}

//用户端-课程下视频列表
export function userPageByCurriculum(data) {
    return $http.post("/video/userPageByCurriculum", data);
}
//用户端-专题下视频列表
export function userPageBySubject(data) {
    return $http.post("/video/userPageBySubject", data);
}



export function videoSave(data) {
    return $http.post("/video/save", data);
}
export function updateFileId(data) {
    return $http.post("/video/updateFileId", data);
}
export function videoSaveSubject(data) {
    return $http.post("/video/saveSubject", data);
}
export function videoSaveSubjectOwn(data) {
    return $http.post("/video/saveSubjectOwn", data);
}


export function saveFilmHistory(data) {
    return $http.post("/video/saveFilmHistory", data);
}

export function filmHistoryList(data) {
    return $http.post("/video/filmHistoryList", data);
}

//视频发布
export function videoEnable(data) {
    return $http.post("/video/enable", data);
}
//视频禁用
export function videoDisable(data) {
    return $http.post("/video/disable", data);
}
export function videoDelete(data) {
    return $http.post("/video/delete", data);
}

export function videoVodDelete(data) {
    return $http.post("/video/deleteVod", data);
}

export function videoPage(data) {
    if (!data || data.origin == 'YKT') {
        return $http.post("/video/page", data);
    } else if (data.origin == 'TENCENT') {
        return $http.post("/video/pageTencent", data);
    } else if (data.origin == 'AIR') {
        return $http.post("/video/pageAir", data);
    } else {
        return $http.post("/video/page", data);
    }
}
export function videoTencentPage(data) {
    return $http.post("/video/pageTencent", data);
}
export function videoAirPage(data) {
    return $http.post("/video/pageAir", data);
}
export function videoAudit(data) {
    return $http.post("/video/audit", data);
}

export function videoExport(data) {
    return $http.post("/video/export", data, {
        responseType: 'blob',
    });
}

export function playExport(data) {
    return $http.post("/play/export", data, {
        responseType: 'blob',
    });
}

export function playInfo(data) {
    return $http.post("/play/info", data);
}


export function playVideo(data) {
    return $http.post("/play/play", data);
}

export function playReport(data) {
    return $http.post("/play/report", data);
}

export function playEnd(data) {
    return $http.post("/play/end", data);
}

export function thumbClick(data) {
    return $http.post("/thumbs/thumb", data);
}

export function thumbCancel(data) {
    return $http.post("/thumbs/cancel", data);
}

export function collectSave(data) {
    return $http.post("/collect/save", data);
}

export function collectDelete(data) {
    return $http.post("/collect/delete", data);
}

export function transpond(data) {
    return $http.post("/transpond/trans", data);
}


export function countCurriculm(data) {
    return $http.post("/count/curriculm", data);
}

export function countVideo(data) {
    return $http.post("/count/video", data);
}

export function curriculmByUser(data) {
    return $http.post("/count/curriculmByUser", data);
}

export function videoByUser(data) {
    return $http.post("/count/videoByUser", data);
}



export function achievementUser(data) {
    return $http.post("/achievement/user", data);
}

export function rolePage(data) {
    return $http.post("/role/page", data);
}

export function roleSave(data) {
    return $http.post("/role/save", data);
}

export function roleDelete(data) {
    return $http.post("/role/delete", data);
}

export function roleSavePermission(data) {
    return $http.post("/role/savePermission", data);
}



//讲师管理list
export function lecturerList(data) {
    return $http
        .post('/lecturer/page', data)
}
//讲师管理info
export function lecturerInfo(data) {
    return $http
        .post('/lecturer/info', data)
}
//讲师管理infoList
export function lecturerPageInfo(data) {
    return $http
        .post('/lecturer/pageInfo', data)
}
//讲师管理save
export function lecturerSave(data) {
    return $http
        .post('/lecturer/save', data)
}
//讲师管理-课程列表
export function lecturerCurriculum(data) {
    return $http
        .post('/lecturer/curriculum', data)
}


//学生page
export function studentPage(data) {
    return $http
        .post('/student/page', data)
}

//播放记录
export function playPage(data) {
    return $http
        .post('/play/page', data)
}

//我的记录
export function playMypage(data) {
    return $http
        .post('/play/mypage', data)
}
//我的收藏
export function collectPage(data) {
    return $http
        .post('/collect/page', data)
}
//用户信息
export function userInfo() {
    return $http
        .post('/user/info')
}
export function searchUserByRole(data) {
    return $http
        .post('/user/searchUserByRole', data)
}

export function permissions() {
    return $http
        .post('/user/permissions')
}
//用户page
export function userPage(data) {
    return $http
        .post('/user/page', data)
}
//用户save
export function userSave(data) {
    return $http
        .post('/user/save', data)
}
//用户删除
export function userDelete(data) {
    return $http
        .post('/user/delete', data)
}
//用户登录
export function userLogin(data) {
    return $http
        .post('/user/login', data)
}
//用户登出
export function userLogOut(data) {
    return $http
        .post('/user/logOut', data)
}

export function roleSaveUser(data) {
    return $http
        .post('/role/saveUser', data)
}

export function permissionList(data) {
    return $http
        .post('/role/permissionList', data)
}

export function rolePermissionList(data) {
    return $http
        .post('/role/rolePermissionList', data)
}

export function userListByRole(data) {
    return $http
        .post('/user/listByRole', data)
}

export function userPageByRole(data) {
    return $http
        .post('/user/pageByRole', data)
}













//课程权限列表
export function curriculumTypeList() {
    return $http
        .post('/curriculumType/page', { currentPage: 1, pageSize: 10 })
}
//课程权限列表
export function curriculumTypePage(data) {
    return $http
        .post('/curriculumType/page', data)
}
//课程权限保存
export function curriculumTypeSave(data) {
    return $http
        .post('/curriculumType/save', data)
}
//课程权限删除
export function curriculumTypeDelete(data) {
    return $http
        .post('/curriculumType/delete', data)
}

//banner
export function bannerPage(data) {
    return $http
        .post('/banner/page', data)
}
export function bannerSave(data) {
    return $http
        .post('/banner/save', data)
}
export function bannerDelete(data) {
    return $http
        .post('/banner/delete', data)
}






//专题list
export function projectList(id) {
    return $http
        .post('/projectManagement/searchById', { id: id })
}
//讲师管理详情
export function lecturerDetail(id) {
    return $http
        .post('/teachers/searchById', { wid: id })
}
//编辑讲师介绍
export function editIntroduce(data) {
    return $http
        .post('/teachers/updateIntroduction', data)
}
//讲师禁用
export function teacherUnUse(data) {
    return $http
        .post('/teachers/disEnable', data)
}
//讲师启用
export function teacherUse(data) {
    return $http
        .post('/teachers/enable', data)
}
//获取讲师照片
export function getphoto(id) {
    return $http
        .post('/common/photo', { wid: id })
}




//学生学习记录列表
export function stuLearnList(data) {
    return $http.post("/stduentClassSeeRecord/studentList", data)
}
//学生学习记录详情
export function stuLearnDetail(data) {
    return $http.post("/stduentClassSeeRecord/get", data)
}
//学生课程记录详情
export function stuCourseDetail(data) {
    return $http.post("/stduentClassSeeRecord/courseList", data)
}
//删除学生记录
export function delStuRecords(data) {
    return $http.post("/stduentClassSeeRecord/delete", data)
}
//删除学生课程列表记录
export function delStuCourse(data) {
    return $http.post("/stduentClassSeeRecord/deleteForClass", data)
}


//专题管理
// 查询专题列表
export function projectManageList(data) {
    return $http.post("/projectManagement/list", data)
}
// 查询专题列表 all
export function projectManageListAll(data) {
    return $http.post("/projectManagement/listall", data)
}
// 查询专题列表
export function delPro(data) {
    return $http.post("/projectManagement/delete", data)
}
//修改专题（包含禁用）
export function updatePro(data) {
    return $http.post("/projectManagement/update", data)
}
//新增专题
export function addPro(data) {
    return $http.post("/projectManagement", data)
}
//查看专题详情
export function proDetail(data) {
    return $http.post("/projectManagement/searchById", data)
}
//所有讲师查询
export function allTeachers(data) {
    return $http.post("/teachers/list", data)
}

// 课程列表查询
export function courseList(data) {
    return $http.post("/curriculum/searchByTeacher", data)
}

export function courseById(data) {
    return $http.post("/curriculum/getById", data)
}

export function courseListAll(data) {
    return $http.post("/curriculum/listall", data)
}
export function courseSearch(data) {
    return $http.post("/curriculum/search", data)
}
//查询学院-院系
export function academy() {
    return $http.post("/common/deptList")
}
//查询专业
export function major(data) {
    return $http.post("/major/selectList", data)
}




//课程列表
export function curriculumAuditList(data) {
    return $http.post("/videoAudit/list", data)
}


//章节
export function chapterList(data) {
    return $http.post("/chapter/list/select", data)
}


//查询课程全部列表
export function listAllDic(data) {
    return $http.post("/classType/listDic", data)
}

//根据课程ID获取章节列表
export function searchchapterbycurrid(data) {
    return $http.post("/videoAudit/searchchapterbycurrid", data)
}

export function searchevaluatebycurrid(data) {
    return $http.post("/videoAudit/searchevaluatebycurrid", data)
}


//通过章节id查视频
export function loadByChapter(data) {
    return $http.post("/video/load/byChapter", data)
}

//保存直播管理接口
export function liveVideoSave(data) {
    return $http.post("/liveVideo/save", data)
}


//评论审核
export function evaluateAudit(data) {
    return $http.post("/classEvaluateAudit/audit", data)
}

//批量评论审核
export function evaluateAuditBatch(data) {
    return $http.post("/classEvaluateAudit/auditBatch", data)
}


//禁用课程
export function curriculumDisable(data) {
    return $http.post("/curriculum/disable", data)
}

export function batchHot(data, cis) {
    return $http.post("/curriculum/hot", { idList: data, cis: cis })
}

export function batchDisHot(data, cis) {
    return $http.post("/curriculum/dishot", { idList: data, cis: cis })
}


//启用课程
export function curriculumEnable(data) {
    return $http.post("/curriculum/enable", data)
}


//保存课程
export function curriculumSave(data) {
    return $http.post("/curriculum/save", data)
}

//编辑课程
export function curriculumUpdate(data) {
    return $http.post("/curriculum/update", data)
}


//根据课程查询学生学习记录
export function stduentClassSeeRecordList(data) {
    return $http.post("/stduentClassSeeRecord/list", data)
}

//导出课程评价
export function classEvaluateExport(data) {
    return $http.post("/classEvaluate/export", data)
}

//批量删除评价
export function classEvaluateBatchDelete(data) {
    return $http.post("/classEvaluate/delete/batch", data)
}

//格式化视频内容
export function formatVideo(data) {
    return $http.post("/video/format", data)
}

//回滚视频
export function revertVideo(data) {
    return $http.post("/video/revert", data)
}

//调整视频
export function adjustVideo(data) {
    return $http.post("/video/adjust", data)
}

//启用/禁用
export function enableFun(data) {
    return $http.post("/projectManagement/enable", data)
}
//获取老师名称 单位
export function casTeacherInfo() {
    return $http.get("/user/casTeacherInfo")
}


// WEBPACK FOOTER //
// ./src/api/man.js